// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-layout-container[data-v-2a2da3a8]{margin:0 auto}@media (min-width:768px){[data-v-2a2da3a8]:root{--media-gap:var(--space-8)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
